<template>
  <auth-layout>
    <code-step
      title="Confirm it's you"
      :verify="verify"
      :resend-code="resend"
      :resend-available-at="challenge.resendAvailableAt || 0"
      :locked-until="challenge.lockedUntil || 0"
      @verified="onVerified"
      @expired="onExpired"
      @resend-at="patchChallenge({ resendAvailableAt: $event })"
      @locked-until="patchChallenge({ lockedUntil: $event })"
    >
      <template #intro>
        This is a new device or browser for your account. We sent a 6-digit code to <b>{{ challenge.email }}</b>.
      </template>
      <template #extra>
        <label class="login-code__trust">
          <input v-model="trustDevice" type="checkbox" data-test="trust-device" />
          <span>Trust this device for 30 days</span>
        </label>
      </template>
    </code-step>
    <p class="pop-auth__fine pop-auth__center" style="margin-top: 20px">
      <router-link class="pop-auth__link" to="/login">Back to log in</router-link>
    </p>
  </auth-layout>
</template>

<script>
import AuthLayout from '../AuthLayout.vue'
import CodeStep from '../CodeStep.vue'
import { finishLogin } from '../session'
import { getDeviceId } from '@/utils/device-id'
import { segmentPage } from '@/utils'

export default {
  name: 'LoginCodePage',
  components: { AuthLayout, CodeStep },
  data() {
    return { trustDevice: true }
  },
  computed: {
    challenge() {
      return this.$store.state.signup.loginChallenge || {}
    },
  },
  created() {
    if (!this.challenge.pendingLoginToken) {
      this.$router.replace('/login')
      return
    }
    segmentPage('LoginCode', {})
  },
  methods: {
    patchChallenge(patch) {
      this.$store.commit('signup/patch', { loginChallenge: { ...this.challenge, ...patch } })
    },
    async verify(code) {
      const response = await this.$store.dispatch('loginConfirmCode', {
        pendingLoginToken: this.challenge.pendingLoginToken, code, trustDevice: this.trustDevice, deviceId: getDeviceId(),
      })
      return response.data
    },
    async resend() {
      const response = await this.$store.dispatch('loginResendCode', {
        pendingLoginToken: this.challenge.pendingLoginToken, deviceId: getDeviceId(),
      })
      return response.data
    },
    onVerified(data) {
      const redirect = this.challenge.redirect || ''
      this.$store.commit('signup/patch', { loginChallenge: null })
      finishLogin(this, { token: data.token, user: data.user }, {
        event: 'login', eventData: { newDevice: true, trusted: this.trustDevice }, redirect,
      })
    },
    onExpired() {
      this.$store.commit('signup/patch', { loginChallenge: null })
      this.$notify({ group: 'info', type: 'warning', text: 'This login expired. Please log in again.' })
      this.$router.replace({ path: '/login', query: { email: this.challenge.email } })
    },
  },
}
</script>

<style scoped lang="scss">
.login-code__trust {
  display: flex; align-items: center; gap: 10px; margin-top: 20px; font-size: 13px; color: #014751; cursor: pointer;
  input { width: 16px; height: 16px; accent-color: #0075ff; }
}
</style>
